export const SET_ACTIVE_ENHANCEMENTS = 'SET_ACTIVE_ENHANCEMENTS'

export const selectedEnhancements = activeEnhancements => ({
	type: SET_ACTIVE_ENHANCEMENTS,
	payload: activeEnhancements
})

export default function setActiveEnhancements(activeEnhancements) {
	return dispatch => {
		dispatch(selectedEnhancements(activeEnhancements))
	}
}



// WEBPACK FOOTER //
// ./src/actions/setActiveEnhancementActions.js